import GhostBanner from '../components/organisms/GhostBanner';
import InternalBanner from '../components/organisms/InternalBanner';
import { registerComponent } from './ComponentRegistry';

export function registerDefaultComponents() {
  registerComponent('GhostBanner', GhostBanner);
  registerComponent('InternalBanner', InternalBanner);
  // Placeholder Phase 1 defaults, expanded in Phase 1F.
  registerComponent('Dashboard', InternalBanner);
}
